import script from "./WholesaleView.vue?vue&type=script&setup=true&lang=js"
export * from "./WholesaleView.vue?vue&type=script&setup=true&lang=js"

import "./WholesaleView.vue?vue&type=style&index=0&id=384c9be8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-384c9be8"]])

export default __exports__